/* eslint-disable sonarjs/cognitive-complexity */
import { BaSeTheme, BaSeTooltip } from '@base/react';
import * as React from 'react';
import { useInterviewController } from '../../../../hooks/controllers/interview-controller';
import { useCandidateInterview } from '../../pages/candidates/hook/useCandidateInterview';
import { BoxTag } from './data-table-styled';
import { Tag } from './tag';

export const InterviewStatus = ({ props }) => {
  const { getStatusCompletingInterview } = useInterviewController();
  const { formatDate } = useCandidateInterview();
  const [status, setStatus] = React.useState('');
  const [tooltipOpen, setTooltipOpen] = React.useState(false);

  const DATA_ENVIO = isNaN(
    formatDate(new Date(props?.sendingReinterviewEmail?.sendEmailDate)),
  )
    ? `Enviado: ${formatDate(
        new Date(props?.sendingReinterviewEmail?.sendEmailDate),
      ).toString()}`
    : '';

  const DATA_ABERTURA =
    props?.sendingReinterviewEmail?.openedEmailDate !== undefined
      ? `Aberto: ${formatDate(
          new Date(props?.sendingReinterviewEmail?.openedEmailDate),
        ).toString()}`
      : 'Não aberto';

  const DATA_ABERTURA_REVISION =
    props?.revisionDate !== undefined
      ? `Aberto: ${formatDate(new Date(props?.revisionDate)).toString()}`
      : 'Não aberto';

  const textToltip = React.useCallback(
    (status) => {
      if (status === 'REENTREVISTA') {
        return [DATA_ENVIO, DATA_ABERTURA];
      }
      return DATA_ABERTURA_REVISION;
    },
    [DATA_ABERTURA, DATA_ABERTURA_REVISION, DATA_ENVIO],
  );

  React.useEffect(() => {
    setStatus(getStatusCompletingInterview(props));
  }, [getStatusCompletingInterview, props]);

  const getStatus = React.useCallback(
    (tagKey, result, icon) => {
      return (
        <>
          <BoxTag
            onMouseEnter={() => setTooltipOpen(true)}
            onMouseLeave={() => setTooltipOpen(false)}
          >
            <Tag tagKey={tagKey} label={result} icon={icon} />
            <BaSeTooltip
              color={BaSeTheme.colors.institucionais.cinzaSebrae60}
              direction="bottom"
              coordinates={{ top: '34px' }}
              message={textToltip(props?.statusCompletingInterview)}
              messageNoBreakLine
              open={tooltipOpen}
            />
          </BoxTag>
        </>
      );
    },
    [textToltip, props, tooltipOpen],
  );

  const statusCompletingInterview = {
    FINALIZADA: <Tag tagKey="done" label={status} icon="check" />,
    DESISTENTE: <Tag tagKey="error" label={status} icon="close" />,
    EM_PREENCHIMENTO: <Tag tagKey="default" label={status} icon="clock" />,
    EXPIRADA: <Tag tagKey="default" label={status} icon="times" />,
    EM_REVISAO: getStatus('default', status, 'clock'),
    REENTREVISTA: getStatus('default', status, 'clock'),
    CERTIFICADA: <Tag tagKey="done" label={status} icon="graduation-hat" />,
  };

  return (
    statusCompletingInterview?.[props.statusCompletingInterview] ?? (
      <Tag tagKey="default" label={status} icon="ban" />
    )
  );
};
